import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ArrowIcon = ({ open }) => {
  return open ? (
    <KeyboardArrowUpIcon sx={{ mr: 2, fontSize: 25 }} aria-hidden />
  ) : (
    <KeyboardArrowDownIcon sx={{ mr: 2, fontSize: 25 }} aria-hidden />
  );
};

export default ArrowIcon;
